var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCt4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 4,
    fill: "#E8FFEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_7023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2385 32.4142L25.8344 45.3832C25.7501 45.5308 25.5613 45.5785 25.4155 45.4913C20.8281 42.747 18 37.7743 18 32.4142C18 24.0547 24.8789 17.1758 33.2385 17.1758C41.4946 17.1758 48.3066 23.8856 48.4738 32.1048C48.4772 32.2744 48.3416 32.4142 48.172 32.4142H33.2385Z",
    fill: "url(#paint0_radial_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2395 32.4153L26.1696 44.7991C21.7166 42.269 18.9844 37.5368 18.9844 32.4153C18.9844 24.5952 25.4194 18.1602 33.2395 18.1602C41.0596 18.1602 47.4946 24.5952 47.4946 32.4153H33.2395Z",
    fill: "url(#paint1_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2387 29.2785C38.3455 29.2785 42.4853 26.8722 42.4853 23.9039C42.4853 20.9356 38.3455 18.5293 33.2387 18.5293C28.132 18.5293 23.9922 20.9356 23.9922 23.9039C23.9922 26.8722 28.132 29.2785 33.2387 29.2785Z",
    fill: "url(#paint2_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0681 18.8125C41.0867 20.8564 41.6608 23.1606 41.6608 25.5994C41.6608 28.0491 41.0818 30.3634 40.0547 32.4141H48.4756C48.4756 32.2952 48.4738 32.1766 48.471 32.0583C48.4704 32.0325 48.4696 32.0067 48.4689 31.9809C48.3056 26.2522 44.9152 21.273 40.0681 18.8125Z",
    fill: "url(#paint3_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7397 42.7402C48.7387 40.2013 49.9485 37.0119 49.9974 33.5415C49.9991 33.4208 49.9005 33.3223 49.7799 33.3223H35.5434C35.2821 33.3223 35.1659 33.6505 35.3689 33.8149L46.4331 42.7734C46.5268 42.8494 46.6652 42.8349 46.7397 42.7402Z",
    fill: "url(#paint4_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9918 33.9023H37.6762C37.415 33.9023 37.2988 34.2306 37.5017 34.395L47.1468 42.2045C48.8387 39.8503 49.8762 36.9944 49.9918 33.9023Z",
    fill: "url(#paint5_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7842 33.3223H48.6629C48.0928 34.3477 47.3944 35.3231 46.5662 36.2255C45.3219 37.5815 43.8885 38.66 42.3438 39.4589L46.4374 42.7734C46.531 42.8493 46.6695 42.8349 46.7441 42.7402C48.743 40.2013 49.9528 37.0119 50.0017 33.5415C50.0035 33.4208 49.9049 33.3223 49.7842 33.3223Z",
    fill: "url(#paint6_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2769 33.3223C45.0956 35.7595 44.1919 37.9948 42.7782 39.8147L35.3688 33.8151C35.1661 33.651 35.2821 33.3223 35.543 33.3223H45.2769Z",
    fill: "url(#paint7_radial_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4717 33.8683L26.2161 46.5781C26.1388 46.7135 26.1889 46.885 26.3257 46.9599C28.4953 48.1479 30.9854 48.8236 33.6334 48.8236C38.313 48.8236 42.4993 46.7135 45.2946 43.3937C45.3951 43.2743 45.3798 43.0961 45.2584 42.9979L33.8869 33.7903C33.754 33.6828 33.5564 33.7199 33.4717 33.8683Z",
    fill: "url(#paint8_radial_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6269 48.8239C38.1761 48.8239 42.2586 46.8296 45.0507 43.6685L34.3535 35.0071C34.2206 34.8996 34.0231 34.9367 33.9383 35.0851L26.9688 47.2939C28.9805 48.2729 31.2391 48.8239 33.6269 48.8239Z",
    fill: "url(#paint9_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2584 42.9977L41.672 40.0938C38.822 44.1333 34.119 46.7721 28.7994 46.7721C27.9227 46.7721 27.0631 46.6992 26.2255 46.5614L26.2161 46.5779C26.1388 46.7133 26.1889 46.8848 26.3257 46.9597C28.4953 48.1477 30.9854 48.8233 33.6334 48.8233C38.313 48.8233 42.4993 46.7133 45.2945 43.3934C45.3951 43.274 45.3797 43.0958 45.2584 42.9977Z",
    fill: "url(#paint10_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1945 40.5166C39.9852 42.9562 36.7917 44.489 33.2412 44.489C31.3906 44.489 29.6378 44.0726 28.0703 43.329L33.4715 33.868C33.5566 33.7198 33.7538 33.6827 33.887 33.7907L42.1945 40.5166Z",
    fill: "url(#paint11_radial_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2365 40.5492C37.7293 40.5492 41.3715 36.9071 41.3715 32.4143C41.3715 27.9214 37.7293 24.2793 33.2365 24.2793C28.7437 24.2793 25.1016 27.9214 25.1016 32.4143C25.1016 36.9071 28.7437 40.5492 33.2365 40.5492Z",
    fill: "url(#paint12_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.235 40.0246C37.4378 40.0246 40.845 36.6175 40.845 32.4147C40.845 28.2118 37.4378 24.8047 33.235 24.8047C29.0321 24.8047 25.625 28.2118 25.625 32.4147C25.625 36.6175 29.0321 40.0246 33.235 40.0246Z",
    fill: "url(#paint13_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2409 30.7404C35.9671 30.7404 38.1771 29.4558 38.1771 27.8712C38.1771 26.2865 35.9671 25.002 33.2409 25.002C30.5147 25.002 28.3047 26.2865 28.3047 27.8712C28.3047 29.4558 30.5147 30.7404 33.2409 30.7404Z",
    fill: "url(#paint14_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.877 25.1367C37.4256 26.2317 37.7349 27.4675 37.7349 28.7757C37.7349 33.2685 34.0927 36.9107 29.6 36.9107C28.2918 36.9107 27.056 36.6014 25.9609 36.0527C27.2966 38.7185 30.0533 40.5487 33.2379 40.5487C37.7307 40.5487 41.3728 36.9066 41.3728 32.4138C41.3728 29.2291 39.5426 26.4724 36.877 25.1367Z",
    fill: "url(#paint15_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3498 36.3688C39.3808 38.1097 37.7904 39.4565 35.8791 40.1117L31.033 35.2656C29.5247 33.7572 28.3569 32.5903 28.3506 32.584C27.9659 32.2662 27.7734 31.764 27.7734 31.078V28.9916C27.7734 28.3064 27.9658 27.8042 28.3506 27.4856C28.7354 27.1671 29.2558 27.0078 29.911 27.0078C30.5615 27.0078 31.0827 27.1671 31.4754 27.4856L33.6918 29.7044L40.3498 36.3688Z",
    fill: "url(#paint16_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3712 32.4141C41.3712 33.8492 40.9998 35.1975 40.347 36.3676C39.3779 38.1086 37.7875 39.4554 35.8763 40.1106C35.0483 40.3952 34.1605 40.549 33.2364 40.549C33.0046 40.549 32.7751 40.5395 32.5488 40.5198L30.1881 38.1812C30.0312 38.0195 29.9531 37.8405 29.9531 37.645C29.9531 37.5567 29.9768 37.4637 30.0249 37.3659L31.0302 35.2645L33.689 29.7033L35.0909 26.7717C35.206 26.5273 35.4079 26.4043 35.6972 26.4043C35.9125 26.4043 36.1112 26.4776 36.2926 26.6251C36.3738 26.6905 36.4361 26.7655 36.481 26.8466L41.3405 31.7069C41.361 31.9402 41.3712 32.176 41.3712 32.4141Z",
    fill: "url(#paint17_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1162 32.2158C37.7239 31.8976 37.2025 31.7383 36.552 31.7383C35.8963 31.7383 35.3761 31.8977 34.9913 32.2158C34.6064 32.5343 34.4141 33.0364 34.4141 33.7219V35.8084C34.4141 36.4942 34.6064 36.9963 34.9913 37.3145C34.9976 37.3198 35.9272 38.2489 37.1985 39.5202C38.519 38.783 39.6134 37.6894 40.3491 36.3676C40.5837 35.9472 40.7813 35.5035 40.939 35.0413L38.1162 32.2158Z",
    fill: "url(#paint18_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.064 31.078V28.9914C32.064 28.3059 31.8678 27.8038 31.4756 27.4854C31.0832 27.1671 30.5618 27.0078 29.9114 27.0078C29.2557 27.0078 28.7354 27.1672 28.3506 27.4854C27.9658 27.8038 27.7734 28.3059 27.7734 28.9914V31.078C27.7734 31.7637 27.9658 32.2659 28.3506 32.584C28.7354 32.9025 29.2557 33.0616 29.9114 33.0616C30.5618 33.0616 31.0832 32.9025 31.4756 32.584C31.8678 32.2659 32.064 31.7637 32.064 31.078ZM30.6534 31.078C30.6534 31.5481 30.406 31.7832 29.9114 31.7832C29.4265 31.7832 29.184 31.5481 29.184 31.078V28.9914C29.184 28.5212 29.4265 28.2862 29.9114 28.2862C30.406 28.2862 30.6534 28.5213 30.6534 28.9914V31.078Z",
    fill: "url(#paint19_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5648 27.183C36.5648 26.9578 36.4742 26.7715 36.2928 26.6247C36.1114 26.4777 35.9128 26.4043 35.6972 26.4043C35.4084 26.4043 35.2063 26.5269 35.0911 26.7716L30.0252 37.3657C29.9769 37.4638 29.9531 37.5567 29.9531 37.6449C29.9531 37.8407 30.0316 38.0196 30.1887 38.1812C30.3457 38.3428 30.542 38.4236 30.7775 38.4236C31.0948 38.4236 31.3113 38.301 31.4271 38.0563L36.5072 27.4622C36.5455 27.3839 36.5648 27.2909 36.5648 27.183Z",
    fill: "url(#paint20_linear_170_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1162 32.2158C37.7238 31.8976 37.2025 31.7383 36.552 31.7383C35.8962 31.7383 35.376 31.8977 34.9912 32.2158C34.6064 32.5343 34.4141 33.0364 34.4141 33.7219V35.8084C34.4141 36.4942 34.6064 36.9963 34.9912 37.3145C35.376 37.6329 35.8962 37.792 36.552 37.792C37.2025 37.792 37.7238 37.6329 38.1162 37.3145C38.5084 36.9963 38.7046 36.4942 38.7046 35.8084V33.7219C38.7046 33.0364 38.5083 32.5342 38.1162 32.2158ZM37.294 35.8084C37.294 36.2786 37.0465 36.5137 36.552 36.5137C36.0671 36.5137 35.8246 36.2786 35.8246 35.8084V33.7219C35.8246 33.2518 36.0671 33.0166 36.552 33.0166C37.0465 33.0166 37.294 33.2518 37.294 33.7219V35.8084Z",
    fill: "url(#paint21_linear_170_7023)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_170_7023",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.1468 24.551) scale(20.8358 20.8358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCE3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAE2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_7023",
    x1: 33.2107,
    y1: 32.4128,
    x2: 20.0323,
    y2: 19.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_170_7023",
    x1: 34.2466,
    y1: 28.1728,
    x2: 31.4756,
    y2: 16.4354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_170_7023",
    x1: 42.4172,
    y1: 29.0627,
    x2: 50.6566,
    y2: 13.7385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_170_7023",
    x1: 41.9564,
    y1: 32.9357,
    x2: 49.3682,
    y2: 40.0321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_170_7023",
    x1: 44.6262,
    y1: 39.3541,
    x2: 42.5761,
    y2: 27.6846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_170_7023",
    x1: 45.9677,
    y1: 38.6943,
    x2: 52.7975,
    y2: 25.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_170_7023",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.286 33.1236) scale(7.64023 7.64021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5053,
    stopColor: "#C3272C",
    stopOpacity: 0.495
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6873,
    stopColor: "#CA2729",
    stopOpacity: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#D52724",
    stopOpacity: 0.183
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    stopColor: "#E6281C",
    stopOpacity: 0.079
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_170_7023",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2412 33.6755) scale(15.1613 15.1613)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_170_7023",
    x1: 34.7558,
    y1: 43.5737,
    x2: 27.344,
    y2: 32.2983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_170_7023",
    x1: 37.1994,
    y1: 43.568,
    x2: 52.4172,
    y2: 28.2714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_170_7023",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1468 34.575) scale(7.73107 7.73106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8532,
    stopColor: "#0469BC",
    stopOpacity: 0.147
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_170_7023",
    x1: 25.1016,
    y1: 32.4143,
    x2: 41.3715,
    y2: 32.4143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_170_7023",
    x1: 33.38,
    y1: 32.4932,
    x2: 26.2442,
    y2: 28.6296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EDF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_170_7023",
    x1: 33.2409,
    y1: 29.9699,
    x2: 33.2409,
    y2: 25.4277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EDF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_170_7023",
    x1: 34.1503,
    y1: 33.7661,
    x2: 53.2317,
    y2: 24.3043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_170_7023",
    x1: 33.7409,
    y1: 33.8451,
    x2: 24.6339,
    y2: 27.0641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_170_7023",
    x1: 36.1595,
    y1: 34.4795,
    x2: 30.6401,
    y2: 31.5621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_170_7023",
    x1: 39.7873,
    y1: 36.8198,
    x2: 33.0457,
    y2: 33.7053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_170_7023",
    x1: 29.9191,
    y1: 30.0392,
    x2: 31.9166,
    y2: 39.3433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_170_7023",
    x1: 32.6248,
    y1: 29.4565,
    x2: 34.6224,
    y2: 38.7607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_170_7023",
    x1: 35.2961,
    y1: 28.8836,
    x2: 37.2936,
    y2: 38.1879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_7023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(18 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt4);
export default __webpack_public_path__ + "static/media/ct4.d51fd3dd613263002bde84e1d9fe6662.svg";
export { ForwardRef as ReactComponent };